module.exports = __webpack_public_path__ + "static/img/award.114475ed.png";